import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Check, Target } from 'lucide-react';
import { Member } from '@/types/member';

interface MatchedSkillsBadgesProps {
  currentUserSkills?: string[];
  currentUserNeeds?: string[];
  memberSkills?: string[];
  memberNeeds?: string[];
  maxVisible?: number;
}

export const MatchedSkillsBadges: React.FC<MatchedSkillsBadgesProps> = ({ 
  currentUserSkills = [],
  currentUserNeeds = [],
  memberSkills = [],
  memberNeeds = [],
  maxVisible = 2
}) => {
  // Compétences que j'ai et que le membre recherche
  const matchedSkills = currentUserSkills.filter(skill => 
    memberNeeds.some(need => need.toLowerCase().includes(skill.toLowerCase()))
  ).slice(0, maxVisible);

  // Compétences que le membre a et que je recherche
  const complementarySkills = memberSkills.filter(skill => 
    currentUserNeeds.some(need => need.toLowerCase().includes(skill.toLowerCase()))
  ).slice(0, maxVisible);

  const allMatches = [...matchedSkills, ...complementarySkills].slice(0, maxVisible);

  if (allMatches.length === 0) return null;

  return (
    <div className="flex gap-1 flex-wrap">
      {matchedSkills.map(skill => (
        <Badge 
          key={`matched-${skill}`} 
          className="text-[10px] px-1.5 py-0.5 gap-1 bg-green-50 text-green-700 border-green-200"
        >
          <Check className="w-3 h-3" />
          {skill}
        </Badge>
      ))}
      {complementarySkills.map(skill => (
        <Badge 
          key={`comp-${skill}`} 
          className="text-[10px] px-1.5 py-0.5 gap-1 bg-blue-50 text-blue-700 border-blue-200"
        >
          <Target className="w-3 h-3" />
          {skill}
        </Badge>
      ))}
    </div>
  );
};

// Fonction helper pour obtenir les compétences matchées
export const getMatchedSkills = (currentUserSkills: string[], memberNeeds: string[]): string[] => {
  return currentUserSkills.filter(skill => 
    memberNeeds.some(need => need.toLowerCase().includes(skill.toLowerCase()))
  );
};

// Fonction helper pour obtenir les compétences complémentaires
export const getComplementarySkills = (memberSkills: string[], currentUserNeeds: string[]): string[] => {
  return memberSkills.filter(skill => 
    currentUserNeeds.some(need => need.toLowerCase().includes(skill.toLowerCase()))
  );
};
